import 'css-chunksrc/client/pages/zonesPage/wbsPage/styles.scss';export default {
  "listsPage": "_listsPage_yid9f_1",
  "header": "_header_yid9f_8",
  "toolbar": "_toolbar_yid9f_19",
  "heading": "_heading_yid9f_35",
  "button": "_button_yid9f_41",
  "main": "_main_yid9f_66",
  "wbs": "_wbs_yid9f_73",
  "statuses": "_statuses_yid9f_77",
  "listsList": "_listsList_yid9f_84",
  "creationMenu": "_creationMenu_yid9f_88",
  "exportButton": "_exportButton_yid9f_92"
};